import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from './Sidebar';
import DepartmentImage from '../../../assets/image/department/rearview-diverse-people-hugging-each-other_53876-156973.jpg';
import DepartmentImage2 from '../../../assets/image/department/colorful-paper-chains-still-life_23-2149254025.jpg';

function FamilyCommunityServices() {

  const [Faq, setFaq] = useState(0);

  const Drop = [
    {
      Que: "What services does this department provide for families?",
      Answer: "The Department of Family and Children Services provides welfare assistance, childcare programs, and resources for family counseling."
    },
    {
      Que: "How can I access community support programs?",
      Answer: "Community support programs can be accessed through local community centers or by contacting our helpline."
    },
    {
      Que: "What initiatives are in place to strengthen communities?",
      Answer: "We focus on community engagement projects, affordable childcare, and support for vulnerable populations."
    }
  ];

  return (
    <>
      <section className="department-details-section">
        <div className="container">
          <div className="row">

            {/* Sidebar */}
            <div className="col-12 col-lg-4 col-xl-4">
              <Sidebar />
            </div>

            {/* Main Content */}
            <div className="col-lg-8">
              <div className="department-details-imgbox">
                <img src={DepartmentImage} className="img-fluid" alt="Family and Children Services" />
              </div>

              <div className="department-details-content-box">
                <h4 className="department-details-title">Family and Children Services</h4>
                <p>
                  The Department of Family and Children Services is dedicated to supporting families and fostering stronger communities through welfare programs, community engagement, and social support services. 
                  Our mission is to create safe and nurturing environments for families to thrive.
                </p>
              </div>

              <div className="department-details-box">
                <div className="department-details-policy">
                  <span>
                    Strengthening families and communities through support and engagement.
                  </span>
                </div>
                <p>
                  Our programs aim to enhance family well-being, provide critical resources for vulnerable populations, and encourage active community participation.
                </p>
              </div>

              <div className="department-details-benefits-inner-box">
                <div className="row row-gutter-30">
                  <div className="col-lg-6">
                    <div className="department-details-benefits-box-image">
                      <img src={DepartmentImage2} className="img-fluid" alt="Community Engagement" />
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="department-details-benefits-box">
                      <h3>Our Benefits</h3>
                      <p>
                        Helping families and communities through tailored support initiatives.
                      </p>
                      <ul className="list-unstyled list-style">
                        <li>
                          <Link to="/department/family-services/family-support">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Family Support and Welfare Assistance
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/family-services/child-youth-development">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Child and Youth Development Programs
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/family-services/domestic-violence-services">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Domestic Violence and Crisis Intervention Services
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/family-services/community-engagement">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Community Engagement and Resource Centers
                          </Link>
                        </li>
                        <li>
                          <Link to="/department/family-services/snap">
                            <i className="fa-solid fa-circle-arrow-right" style={{ marginRight: '5px' }} />
                            Supplemental Nutrition Assistance Program (SNAP)
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="accordian-box">
                {Drop.map((items, index) => (
                  <div className={`accordian-box-item ${Faq !== index && "active"}`} key={index}>
                    <div className="accordian-title">
                      <h5>{items.Que}</h5>
                      <i className="fa-solid fa-angle-right" onClick={() => setFaq(index)} />
                    </div>

                    {Faq === index && (
                      <div className="accordian-content" style={{ display: "block" }}>
                        <p>{items.Answer}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FamilyCommunityServices;
